export const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?`#^()=+{}~'".,<>[\]\\/:;|&_-])[A-Za-z\d@$!%*?`#^()=+{}~'".,<>[\]\\/:;|&_-]{8,}$/;
